function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from 'react';
import styled from 'styled-components';
import { Section } from '../../Section';
import { Carousel, breakPointsSet4 } from '../../Carousel';
import { SkeletonSquare } from '../../Skeleton';
import { ContentProductCard, LastProductCard } from '../ContentProductCard';
var sizes = {
  large: {
    width: 260,
    height: 530
  },
  cta: {
    width: 260,
    height: 530
  }
};
export var SkeletonCard = styled.div.withConfig({
  displayName: "ContentProductsCarousel__SkeletonCard",
  componentId: "sc-a31eh7-0"
})(["height:530px;"]);
export var ContentProductsCarousel = function ContentProductsCarousel(_ref) {
  var products = _ref.products,
    _ref$subscriptions = _ref.subscriptions,
    subscriptions = _ref$subscriptions === void 0 ? [] : _ref$subscriptions,
    _ref$onFollow = _ref.onFollow,
    onFollow = _ref$onFollow === void 0 ? null : _ref$onFollow,
    _ref$onAction = _ref.onAction,
    onAction = _ref$onAction === void 0 ? null : _ref$onAction,
    variant = _ref.variant,
    tag = _ref.tag,
    title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA,
    link = _ref.link,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    _ref$viewMore = _ref.viewMore,
    viewMore = _ref$viewMore === void 0 ? null : _ref$viewMore,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? [] : _ref$context,
    _ref$distributorsWhit = _ref.distributorsWhiteList,
    distributorsWhiteList = _ref$distributorsWhit === void 0 ? [] : _ref$distributorsWhit;
  var aditionalProps = {};
  if (sizes.hasOwnProperty(variant)) {
    aditionalProps.itemWidth = sizes[variant].width;
  }
  return React.createElement(Section, {
    title: title || null,
    subtitle: subtitle || null,
    link: link || null,
    bottomMargin: bottomMargin
  }, products.length ? React.createElement(Carousel, _extends({
    breakpoints: breakPointsSet4
  }, aditionalProps), [].concat(_toConsumableArray(products.map(function (product, index) {
    return React.createElement(ContentProductCard, {
      key: index,
      position: index,
      product: product,
      variant: variant || 'large',
      tag: tag || null,
      following: subscriptions.includes(product.entity.id),
      onFollow: onFollow,
      onAction: onAction ? function () {
        return onAction(product);
      } : null,
      withSPA: withSPA,
      context: context,
      distributorsWhiteList: distributorsWhiteList
    });
  })), _toConsumableArray(viewMore ? [React.createElement(LastProductCard, {
    key: products.length + 1,
    position: products.length + 1,
    variant: variant || 'large',
    viewMore: viewMore
  })] : []))) : React.createElement(Carousel, _extends({
    breakpoints: breakPointsSet4
  }, aditionalProps), [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(function (placeholderId) {
    return React.createElement(SkeletonCard, {
      key: placeholderId
    }, React.createElement(SkeletonSquare, {
      style: {
        height: '100%'
      }
    }));
  })));
};